export const NAMESPACE = 'job';

export const COMMANDS_FETCH_LOADING = 'loading';
export const COMMANDS_FETCH_FAILURE = 'failure';
export const COMMANDS_FETCH_SUCCESS = 'success';

export const TEST_NAME_MAX_CHAR_LENGTH = 255;
export const TEST_NAME_CHAR_BYTE_MAX_LENGTH = 3;
